import type { ColumnsType } from "@similarweb/pro-logic-components";

/**
 * Makes sure that the sum of the widths of all visible columns is at least {X}px.
 * If it's not, it sets the width of the last visible column to undefined,
 * which will make it take up the remaining space.
 *
 * NOTE: Hidden columns are ignored
 *
 * NOTE: This function mutates the original columns value
 *
 * @param {ColumnsType<T>} columns
 * @defaultValue `[]`
 * @param {number} tableWidth
 * @defaultValue `1366`
 *
 * @returns {void} void 0
 */
export const ensureDynamicColumnWidth = <T = unknown>(columns: ColumnsType<T> = [], tableWidth = 1366): void => {
    const visibleColumns = columns.filter((col) => !col.hidden);
    const isEachColumnSet = visibleColumns.every((col) => {
        const acceptableTypeOfNumber = typeof col.width === "number" || typeof col.width === "undefined";
        if (!acceptableTypeOfNumber) {
            console.warn(`Column ${col.title} width must be a number or undefined, check Ant Table for more details`);
        }
        return acceptableTypeOfNumber;
    });

    if (isEachColumnSet) {
        const totalWidth = visibleColumns.reduce((acc, cur) => (cur.width ? acc + cur.width : acc), 0);
        if (totalWidth < tableWidth) {
            const lastVisibleColumn = columns
                .slice()
                .reverse()
                .find((column) => !column.hidden);
            if (lastVisibleColumn) {
                lastVisibleColumn.width = undefined;
            }
        }
    }
};
